const plural = {
  Natuurgebied: { plural: 'Natuurgebieden' },
  Infopunt: { plural: 'Infopunten' },
  Horeca: { plural: 'Horeca' },
  Erfgoed: { plural: 'Erfgoedlocaties' },
  Wandelroute: { plural: 'Wandelroutes' },
  Fietsroute: { plural: 'Fietsroutes' },
  Ruiterpad: { plural: 'Ruiterpaden' },
  'Rolstoel- en kinderwagenroute': { plural: 'Rolstoel- en kinderwagenroutes' },
  Kinderactiviteit: { plural: 'Kinderen en families' },
  Uitkijkpunt: { plural: 'Uitkijkpunten' },
  Parkeerplaats: { plural: 'Parkeerplaatsen' },
  Project: { plural: 'Projecten' },
  Activiteit: { plural: 'Activiteiten' },

  'Natuur- & Landschapbescherming': { plural: 'Natuur- en Landschapsbeheer' },
}

export default plural
